<template>
  <div class="repair-user-block rounded-lg border border-slate-200 bg-white p-3 h-full">
    <div class="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-2">
      {{ roleLabel }}
    </div>
    <div class="flex items-start gap-3">
      <div
        class="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center overflow-hidden shrink-0 border border-slate-200"
      >
        <img
          v-if="user?.picture_profile?.small"
          :src="user.picture_profile.small"
          class="w-10 h-10 object-cover"
          alt=""
        />
        <i v-else class="pi pi-user text-slate-400"></i>
      </div>
      <div class="min-w-0 flex-1 space-y-1.5">
        <CopyLine label="Name" :value="displayName" />
        <CopyLine label="Email" :value="displayEmail" />
        <CopyLine label="ID" :value="displayId" mono />
      </div>
    </div>
  </div>
</template>

<script>
import CopyLine from './CopyLine.vue';

export default {
  name: 'UserRepairCell',
  components: { CopyLine },
  props: {
    roleLabel: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    displayName() {
      return this.user?.name || '—';
    },
    displayEmail() {
      return this.user?.email || '—';
    },
    displayId() {
      return this.user?.id || '—';
    },
  },
};
</script>
